var _d = new Date();

var today = _d.getFullYear().toString() + zeroPad(_d.getMonth() + 1) + zeroPad(_d.getDate().toString());

var todayNum = zeroPad(_d.getDate().toString());

var todayMs = (new Date(_d.getFullYear(), _d.getMonth(), _d.getDate(), 0, 0, 0, 0)).getTime();

var eventKeys = {

	dayNames: ['events_mon', 'events_tue', 'events_wed', 'events_thu', 'events_fri', 'events_sat', 'events_sun'],

	monthNames: ['events_jan', 'events_feb', 'events_mar', 'events_apr', 'events_may', 'events_jun', 'events_jul', 'events_aug', 'events_sep', 'events_oct', 'events_nov', 'events_dec']

};

var wtPrefix = 'forums_event_calendar-';



function calendar(target) {

	var t = this;

	t.root = target;

	t.cache = new cache();

	t.em = new eventManager();

	t.current = {};

	t.thisCal = {};

	t.masterDataList = false;



	t.init = function() {

		var events_title = $("#events_title") == 'events_title' ? 'PSN Events' : $("#events_title").html();

		t.root.html('<div id="upcomingEvents"><div id="upcomingEventsContent"></div></div>' + '<div id="eventCalendar"><div id="eventCalendarNav"><div id="eventCalendarNavPrev">&lt;</div><div id="eventCalendarNavNext">&gt;</div></div><div id="eventCalendarContent"></div><div class="masterEventList"></div><div class="clear-both">&nbsp;</div>');

		t.root.addClass('pageSection');

		t.root.prepend('<hgroup class="sectionHeader"><h1>' + $('#event_title_1').html() + '</h1><h2>' + $('#event_title_2').html() + '</h2></hgroup>');

		//t.root.html('<div class="mainEventFeed"><div id="eventOverlay" class="gradient"><div id="eventClose"></div><div id="eventOverlayContent"></div></div><div id="eventCalendarNav"><div id="eventCalendarNavPrev">&lt;</div><div id="eventCalendarNavNext">&gt;</div></div><div id="eventCalendarContent"></div><div id="upcomingEvents"><h2>'+$('#events_upcoming').html()+'</h2><div id="upcomingEventsContent"></div></div></div><div class="calenderPart"><div id="eventCalendar"></div></div>');

		t.calendarRoot = $('#eventCalendarContent');

		t.navPrev = $('#eventCalendarNavPrev');

		t.navNext = $('#eventCalendarNavNext');

		t.navPrev.click(t.getPrev).hide();

		t.navNext.click(t.getNext);



		var month = (new Date).getMonth() + 1;

		var year = (new Date).getFullYear();

		t.thisCal.month = month;

		t.thisCal.year = year;



		t.get(month, year);

	};



	t.get = function(month, year) {

		var key = 'cal' + month + year;

		t.current = {

			key: key,

			month: month,

			year: year

		};



		var calData = t.cache.retrieve(key);

        var locale = eM.getLocale();

        if(!locale) {

        	locale = "en_GB";

        }

		if (!calData) {

			$.ajax({

				type: 'GET',

				dataType: 'jsonp',

				jsonpCallback: 'calData',

				url: 'http://forumadsales.software.eu.playstation.com/events/calendar/get/lt/' + locale + '/' + year + '/' + month,

				success: t.onAjaxSuccess,

				error: t.onAjaxError

			});

		}

		else {

			t.render(calData);

		}

	};



	t.render = function(html) {

		t.calendarRoot.html(html);

		t.postRender();

	};



	t.postRender = function() {

		$('.has-event').click(t.onDayClick);

		t.buildMasterEventList();

		t.buildUpcoming();

		t.addTracking();

	};



	t.addTracking = function(){

		$("#events-calendar").find("a").each(function(){

			var t = $(this);

			t.click(function(){

				if(typeof(sui_sc) != "undefined"){

					if(t.find("h2").length > 0){

						var label = sui_sc.prepText(t.find("h2").text());

						var locat = "event-big-list";

					} else {

						var label = sui_sc.prepText(t.text());

						var locat = "event-small-list";

					}

					sui_sc.track({

						a : this,

						kind : "o",

						vars : ["events", "prop49", "eVar49"],

						title : "event " + label,

						props : {

							49 : "link:"+locat+":" + label + ":" + sui_sc.getButtonPageName()

						},

						evars : {

							49 : "D=c49"

						},



						events : [sui_sc.events.event66]

					});

				}



			});

		});

	};



    t.buildMasterEventList = function () {

    	var listObject = $('.masterEventList');

    	//listObject.html('');



    	for (var i in t.masterDataList.days) {

    		if('events' in t.masterDataList.days[i]) {

    			var day = t.masterDataList.days[i];

    			if(todayNum == day.num) {

    				var isHidden = '';

    			} else {

    				var isHidden = 'style="display:none;"';

    			}

    			var dayObject = $('<div class="eventDay" ' + isHidden + '></div>');

    			dayObject.data('month',t.masterDataList.month);

    			dayObject.data('day',day.num);

    			dayObject.append('<h3>' + day.num + ' ' + $('#' + eventKeys.monthNames[t.masterDataList.month - 1]).html() + '</h3>');

    			for(var j in day.events) {



    				var event = day.events[j];

    				//format date strings
    				var startArray = event.start.split('-');
    				var endArray = event.end.split('-');

    				var startString = startArray[3] + ":" + startArray[4];
    				var endString = endArray[3] + ":" + endArray[4];

    				var eventObject = $('<div class="event"></div>');

    				eventObject.append('<div class="image"><img src="' + event.image + '" width="100"" /></div>');

    				var mainContentObject = $('<div class="main"></div>');

    				mainContentObject.append('<p class="times">' + startString + ' - ' + endString +'</p>');

    				mainContentObject.append('<p class="title"><a href="' + event.url + '">' + event.title + '</a></p>');



    				eventObject.append(mainContentObject);

    				eventObject.append('<div class="clear-both"></div>');

    				dayObject.append(eventObject);

    			}

    			listObject.append(dayObject);



    		}

    	}





    };



	t.buildUpcoming = function() {

		var maxCount = 3;

		var count = 0;

		var str = '';

		for (e in t.em.events) {

			var c = t.em.events[e];

			if (e < today) {

				continue;

			}

			else {



				str += '<div class="upcoming-day"><p class="date">' + e.slice(6,8) + '</p><p class="month">' + $('#'+eventKeys.monthNames[parseInt(e.slice(4,6),10)-1]).html() + '</p></div>';

				var first = true;

				for (f in c) {

					if(first) {

						//do nothing

						first = false;

						var spacingElement = $('');

					} else {

						//append spacer

						var spacingElement = $('<div class="date-spacer">&nbsp;</div>');

					}

					g = c[f];

					//str += '<div class="upcoming-event"><img src="' + g.image + '" width="290"/><a href="' + g.url + '">' + g.start.slice(11,13) + ':' + g.start.slice(14,16) + ' - ' + g.title + '</a></div>';

				    //sanitise description field

				    var desc = $(g.desc).text();

				    //check if ellipsis is required

				    if(desc.length > 200) {

				    	var ellipsis = ' ...';

				    } else {

				    	var ellipsis = '';

				    }

				    //truncate description field

				    desc = desc.slice(0,200) + ellipsis;

				    var start = g.start.slice(11,13) + ':' + g.start.slice(14,16);

				    var end = g.end.slice(11,13) + ':' + g.end.slice(14,16);

				    //build event elements

				    var eventElement = $('<div class="upcoming-event"></div>');

				    var imageSection = $('<div class="image"></div>');
				    g.image = g.image.replace(' ', '%20');
				    imageSection.css({

				    	'background-image' : 'url(' + g.image + ')',

				    	'background-size' : 'cover',



				    });

				    var mainSectionString = '<div class="event-main"><a href="' + g.url + '"><h2>' + g.title + '</h2></a>';

				    mainSectionString += '<p class="time start">' + $('#event_starts').html() + ': <strong>' + start + '</strong></p>';

				    mainSectionString += '<p class="time end">' + $('#event_ends').html() + ': <strong>' + end + '</strong></p>';

				    mainSectionString += '</div><div class="clear-both"></div>';

				    var mainSection = $(mainSectionString);



				    //compile elements into one item

				    eventElement.append(spacingElement);

				    eventElement.append(imageSection);

				    eventElement.append(mainSection);



				    //add element string

				    str += $('<div></div>').append(eventElement.clone()).html();

					count++;

					if (count >= maxCount) break;

				}

			}



			if (count >= maxCount) break;

		}

		if(count < 1) {

			str = '<p class="no-events">There are currently no events on this date.</p>';

		}

		$('#upcomingEventsContent').html(str);



		//after rendering list, loop through and make all images right height

		$('div.upcoming-event').each(function () {

			var $this = $(this);

			var idealHeight = $this.find('div.event-main').height();

			//correct for padding

			var actualHeight = idealHeight + 16;

			$this.find('div.image').height(actualHeight);

			var $prev = $this.prev();

			if($prev.hasClass('upcoming-day')) {

				$prev.height(actualHeight).css('background','#363636');



			}

		});

	};



	t.onAjaxSuccess = function(data, textStatus, jqXHR) {

		var html = t.buildView(data);

		t.masterDataList = data;

		t.cache.store(t.current.key, html);

		t.render(html);

	};



	t.onAjaxError = function() {

		console.log('An error occurred');

		//t.init();

	};



	t.buildView = function(data) {

		var weeks = [];

		weeks[0] = '';

		var str = '<h2>' + $('#'+eventKeys.monthNames[data.month-1]).html() + ' ' + data.year + '</h2><div class="table">';



		str += '<div class="table-row">';

		for (i in data.day_names) {

			str += '<div class="table-cell column-header">' + $('#'+eventKeys.dayNames[i]).html() + '</div>';

		}

		str += '</div>';



		for (var i = 0; i < data.padding_start; i++) {

			weeks[0] += '<div class="table-cell blank"></div>';

		}



		for (d in data.days) {

			var week = data.days[d].week;

			var classStr = 'table-cell day';

			if (typeof weeks[week] == 'undefined')

				weeks[week] = '';



			if (typeof data.days[d].events != 'undefined') {

				classStr += ' has-event';

				t.em.put(d, data.days[d].events);

			}



			if (d == today)

				classStr += ' today';



			weeks[week] += '<div class="' + classStr + '" data-d="' + d + '">' + data.days[d].num + '</div>';

		}



		for (w in weeks) {

			str += '<div class="table-row">';

			str += weeks[w];

			str += '</div>';

		}



		str += '</div>';



		return str;

	};



	t.onDayClick = function() {

		var day = $(this).data('d');

		var events = t.em.get(day);

		var dayNum = parseInt(String(day).slice(6,8));

		var monthNum = parseInt(String(day).slice(4,6));

		var alreadyPresent = new Array();

		$('div.eventDay').each(function () {$(this).hide()});

		$('div.eventDay').each(function () {

			var eventDay = $(this);

			if(dayNum == eventDay.data('day') && monthNum == eventDay.data('month')) {

				eventDay.show();

				return false;

			}

		});

		//var ad = wtPrefix + eM.getLocale() + '-' + day;

		//wt.track('click', ad);

		//wt.track('view', ad);

	};



	t.getNext = function() {

		var isDec = (t.current.month == 12);

		var month = isDec ? 1 : t.current.month + 1;

		var year = isDec ? t.current.year + 1 : t.current.year;



		if ((year == t.thisCal.year && month > t.thisCal.month) || (year > t.thisCal.year))

			t.navPrev.show();



		t.get(month, year);

	};



	t.getPrev = function() {

		var isJan = (t.current.month == 1);

		var month = isJan ? 12 : t.current.month - 1;

		var year = isJan ? t.current.year - 1 : t.current.year;



		if (year <= t.thisCal.year && month <= t.thisCal.month)

			t.navPrev.hide();



		t.get(month, year);

	};

}







function eventManager() {

	var t = this;

	t.events = {};



	t.put = function(day, events) {

		t.events[day] = events;

	};



	t.get = function(day) {

		return (typeof t.events[day] != 'undefined') ? t.events[day] : false;

	};

}



function cache() {

	var t = this;

	t.cacheStore = {};



	t.keyExists = function(key) {

		return (typeof t.cacheStore[key] != 'undefined');

	};



	t.store = function(key, data) {

		t.cacheStore[key] = data;

	};



	t.retrieve = function(key) {

		return (t.keyExists(key) ? t.cacheStore[key] : false);

	};

}



function zeroPad(n) {

	if (n < 10) n = '0' + n;

	return '' + n;

}



var ev = {

	init: function() {



		var stop_condition = (new RegExp('MSIE [67]\.(?!.*Trident/[5-9])', 'i')).test(navigator.userAgent);



		if (!stop_condition) {

			var c = new calendar($('section#events-calendar div.sectionInner'));

			c.init();

			$('#next').click(c.getNext);

			$('#prev').click(c.getPrev);

		}

	}

};